import React, { useCallback, useState } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { PreventLeaveModal } from '@/modules/core/components';
import { useHistory } from '@/modules/core/hooks';
import { useMyEnrollments } from '@/modules/transaction';

import FundingAmount from '../BuySell/FundingAmount';

import { ManagedWrapper } from '.';
interface Props {
  accountId: string;
  isSwitchMode?: boolean;
  isEmptyPortfolioMode?: boolean;
}
const ManagedSwitchFundingAmount: React.FC<Props> = ({ accountId, isSwitchMode, isEmptyPortfolioMode }) => {
  const [isPreventLeave, setPreventLeave] = useState(isSwitchMode && isEmptyPortfolioMode ? true : false);
  const { currentMyAccount, isLoading } = useMyEnrollments(accountId);

  const history = useHistory();
  const handleBack = useCallback(() => {
    if(isEmptyPortfolioMode) {
      history.push(ROUTES.MANAGED_SWITCH_EMPTY_QUESTIONNAIRE(accountId));
    } else {
      history.goBack();
    }
  }, [accountId, history, isEmptyPortfolioMode]);

  const handleNext = useCallback(async () => {
    setPreventLeave(false);
    if(isEmptyPortfolioMode) {
      history.push(ROUTES.MANAGED_SWITCH_EMPTY_ALLOCATION(accountId)); 
    }  else {
      history.push(ROUTES.MANAGED_SWITCH_ALLOCATION(accountId));
    }
  }, [accountId, history, isEmptyPortfolioMode]);

  if (isLoading) {
    return <Preloader />;
  }
  return (
    <ManagedWrapper isSwitchMode={isSwitchMode} isEmptyPortfolioMode={isEmptyPortfolioMode} currentStep={2}>
      <PreventLeaveModal isPrevent={isPreventLeave} />
      <Box  pad={{ horizontal: '40px', bottom: '40px' }}>
        <FundingAmount
          onCancel={handleBack}
          isSwitchMode
          onNext={handleNext}
          currentMyAccount={currentMyAccount}
          step={2}
          stepLength={isEmptyPortfolioMode ? 3 : 2}
          accountId={accountId}
        />
      </Box>
    </ManagedWrapper>
  );
};
export default ManagedSwitchFundingAmount;
